module.exports = __webpack_public_path__ + "img/rolremovebg-preview.6ab6b071.png";